export interface DedupKey {
    action: string;
    relation?: string;
    lifeEvent?: string;
    fieldName?: string;
    objectName?: string;
}

export interface DedupTracker {
    shouldTrack: (key: DedupKey) => boolean;
    reset: (predicate?: (key: DedupKey) => boolean) => void;
}

const STORAGE_DELIMITER = "\u0000";

const toStorageKey = (key: DedupKey): string =>
    [key.action, key.relation ?? "", key.lifeEvent ?? "", key.fieldName ?? "", key.objectName ?? ""].join(
        STORAGE_DELIMITER,
    );

export const createDedupTracker = (): DedupTracker => {
    const seen = new Map<string, DedupKey>();

    return {
        shouldTrack: (key) => {
            const storageKey = toStorageKey(key);
            if (seen.has(storageKey)) {
                return false;
            }
            seen.set(storageKey, key);
            return true;
        },
        reset: (predicate) => {
            if (!predicate) {
                seen.clear();
                return;
            }
            for (const [storageKey, key] of seen) {
                if (predicate(key)) {
                    seen.delete(storageKey);
                }
            }
        },
    };
};
